import { makeAutoObservable } from 'mobx';

import { message } from 'antd';
import { State } from '../../enum/state';
import http from '../../services/http';
import { IResultDto } from '../../models/ResultDto';

export default class AdminRoutesStore {
  data?: IRoute[];

  item?: IRoute;

  isLoading = false;

  state: State = 'None';

  note: 'None' | 'New' = 'None';

  async findAll() {
    this.isLoading = true;
    try {
      const result = await http.get('/routes');

      const value = result.data as IResultDto<IRoute[]>;
      this.data = value.data;
    } finally {
      this.isLoading = false;
    }
  }

  async onCreate(values: any) {
    this.isLoading = true;
    try {
      const result = await http.post('/routes', values);
      const value = result.data as IResultDto<IRoute>;
      this.data?.push(value.data);
      message.success({ content: value.message });
    } finally {
      this.isLoading = false;
      this.state = 'None';
    }
  }

  async onRead(id?: string) {
    if (!id) return;
    this.isLoading = true;
    try {
      const result = await http.get(`/routes/${id}`);
      const value = result.data as IResultDto<IRoute>;
      this.item = value.data;
      this.state = 'Edit';
    } finally {
      this.isLoading = false;
    }
  }

  async onUpdate(values: any) {
    this.isLoading = true;
    try {
      const result = await http.put(`/routes/${this.item?.id}`, values);
      const value = result.data as IResultDto<IRoute>;
      if (this.data) {
        this.data = this.data.map((x) => {
          if (x.id === value.data.id) x = value.data;
          return x;
        });
      }
      this.item = value.data;
      message.success({ content: value.message });
      this.state = 'None';
    } finally {
      this.isLoading = false;
    }
  }

  async onDelete(id: string) {
    this.isLoading = true;
    try {
      const result = await http.delete(`/routes/${id}`);
      const value = result.data as IResultDto<any>;
      if (this.data) {
        this.data = this.data.filter((e) => e.id !== id);
      }
      message.success({ content: value.message });
      this.state = 'None';
    } finally {
      this.isLoading = false;
    }
  }

  constructor() {
    makeAutoObservable(this);
  }
}

interface IRoute {
  id: string;
  name: string;
  url: string;
}
